import React from 'react';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import { TournamentSponsor } from 'models/tournament';

const normaliseLink = (value: string) => {
   const link = String(value || '').trim();
   return link && !/^https?:\/\//i.test(link) ? `https://${link}` : link.replace(/^http:\/\//i, 'https://');
};

export default function Sponsors({ sponsors }: { sponsors: TournamentSponsor[] }) {
   return <div className='union-tournament__sponsors'>
      {sponsors.map((sponsor, index) => {
         const link = normaliseLink(sponsor.link);
         const content = <>{sponsor.picUrl ? <img src={sponsor.picUrl} alt='' /> : <HandshakeOutlinedIcon />}<strong>{sponsor.name || `Sponsor ${index + 1}`}</strong>{link && <OpenInNewRoundedIcon className='is-external' />}</>;
         return link
            ? <a href={link} target='_blank' rel='noreferrer' key={`${sponsor.name}-${index}`}>{content}</a>
            : <article key={`${sponsor.name}-${index}`}>{content}</article>;
      })}
   </div>;
}
